<div class="settings-page">
  <div class="settings-header">
    <h1>Einstellungen</h1>
  </div>
  <div class="settings-list">
    <a *ngFor="let category of categories" [routerLink]="['/settings', category.id]" class="settings-category-item">
      <span class="icon"
        ><mat-icon>{{ category.icon }}</mat-icon></span
      >
      <span class="title">{{ category.title }}</span>
      <mat-icon class="chevron">chevron_right</mat-icon>
    </a>
  </div>
</div>
